import { ReactNode } from 'react';
import { Provider, Root, Trigger, Content } from '@radix-ui/react-tooltip';
import { PopperContentProps } from '@radix-ui/react-popper';

export const Tooltip = ({
  trigger,
  children,
  align = 'start',
  side = 'top',
  tooltipTitle,
  sideOffset = 0,
}: {
  trigger: ReactNode;
  children?: ReactNode;
  align?: PopperContentProps['align'];
  side?: PopperContentProps['side'];
  tooltipTitle?: string;
  sideOffset?: number;
}) => {
  return (
    <Provider delayDuration={0}>
      <Root>
        <Trigger asChild>
          <div>{trigger}</div>
        </Trigger>
        {children && (
          <Content
            align={align}
            side={side}
            alignOffset={12}
            sideOffset={sideOffset}
            className="rounded-xl border border-neutral-800 bg-neutral-950 z-10
                    text-xs max-w-[300px] p-3 text-neutral-400 font-normal normal-case
                    animate__animated animate__fadeIn animate__delay-0.3s animate__faster"
          >
            {tooltipTitle ? <h6 className="font-bold text-lg text-white uppercase mb-2">{tooltipTitle}</h6> : null}
            {children}
          </Content>
        )}
      </Root>
    </Provider>
  );
};
